import * as React from 'react';
import { useEffect, useState } from 'react';

import AccountLink from 'bundles/third-party-auth/components/AccountLink/AccountLink';
import thirdPartyAuth from 'bundles/third-party-auth/lib';

const AccountLinkingPreferences = () => {
  const showAccountLinking = thirdPartyAuth.facebook.enabled ?? false;
  const [hasMounted, setHasMounted] = useState(false);

  useEffect(() => {
    thirdPartyAuth.facebook.init();
    setHasMounted(true);
  }, []);

  if (!hasMounted || !showAccountLinking) {
    return null;
  }

  return <AccountLink />;
};

export default AccountLinkingPreferences;
